import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ResponseMessageType } from "~/domains";

type RequestDataType = {
  salesConceptCategoryId: string;
  id: string;
};

const request = ({ id, salesConceptCategoryId }: RequestDataType) => {
  return new ApiClient()
    .delete<ResponseMessageType>(
      `/api/managers/sales_concept_categories/${salesConceptCategoryId}/sales_concepts/${id}`,
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisManagersSalesConceptCategoriesSalesConceptsDestroy = ({
  options = {},
}: PropsType = {}): UseMutationResult<ResponseMessageType, RequestDataType> => {
  return useMutation(request, { ...options });
};
